import { z } from 'zod'

export const RoleBase = z.object({ id: z.string(), name: z.string() })
export const Permission = z.object({ codename: z.string(), name: z.string() })
// Session returns a minimal user object from backend. Accept extra fields if present.
export const UserSession = z
  .object({
    id: z.union([z.string(), z.number()]).transform((v) => String(v)),
    email: z.string().email()
  })
  .passthrough()

export const SessionSchema = z.object({
  authenticated: z.boolean(),
  needs_email_verify: z.boolean(),
  needs_mfa: z.boolean(),
  user: UserSession.nullable(),
  roles: z.array(RoleBase),
  permissions: z.array(Permission)
})
export type Session = z.infer<typeof SessionSchema>

export const LoginResponseSchema = z.object({
  mfa_required: z.boolean(),
  pending_mfa_token: z.string().nullable(),
  needs_email_verify: z.boolean()
})
export type LoginResponse = z.infer<typeof LoginResponseSchema>
